import { Link, NavLink, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Menu, X, Zap, LogIn } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

const LINKS = [
  { to: "/dashboard", label: "Dashboard", id: "dashboard" },
  { to: "/batch", label: "Batch Processing", id: "batch" },
  { to: "/billing", label: "Billing", id: "billing" },
  { to: "/account", label: "Account", id: "account" },
];

export const SuiteLogo = () => (
  <Link to="/" className="flex items-center gap-2.5 group" data-testid="suite-logo">
    <span className="w-9 h-9 rounded-lg bg-gradient-to-br from-cyan-400 via-purple-600 to-emerald-400 flex items-center justify-center shadow-[0_0_18px_rgba(0,242,254,0.45)] transition-transform group-hover:rotate-6">
      <Zap size={18} className="text-white" strokeWidth={2.6} />
    </span>
    <span className="leading-none">
      <span className="block font-display font-extrabold text-white text-[17px] tracking-tight">AI Image Suites</span>
      <span className="block font-mono text-[9px] tracking-[0.35em] text-cyan-300">BATCH FILES</span>
    </span>
  </Link>
);

export function SuiteNav({ credits }) {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const linkCls = ({ isActive }) =>
    `px-3 py-2 rounded-md text-sm font-medium transition-colors ${isActive ? "text-white bg-white/10" : "text-slate-400 hover:text-white hover:bg-white/5"}`;
  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-[#080B10]/75 border-b border-white/10" data-testid="suite-nav">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-4">
        <SuiteLogo />
        <nav className="hidden md:flex items-center gap-1">
          {LINKS.map((l) => <NavLink key={l.id} to={l.to} className={linkCls} data-testid={`suite-nav-${l.id}`}>{l.label}</NavLink>)}
        </nav>
        <div className="flex items-center gap-2">
          {user && credits != null && (
            <button onClick={() => nav("/billing")} className="hidden sm:flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-emerald-400/40 bg-emerald-400/10 text-emerald-300 font-mono text-xs" data-testid="suite-nav-credits">
              <Zap size={12} /> {credits} credits
            </button>
          )}
          {!user && (
            <button onClick={() => login("/dashboard")} className="flex items-center gap-1.5 px-4 py-2 rounded-full bg-white text-slate-950 text-sm font-semibold hover:bg-cyan-100 transition-colors" data-testid="suite-nav-signin">
              <LogIn size={15} /> Sign in
            </button>
          )}
          <button className="md:hidden p-2 text-slate-300" onClick={() => setOpen((v) => !v)} data-testid="suite-nav-menu" aria-label="Menu">
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>
      {open && (
        <nav className="md:hidden border-t border-white/10 px-4 py-3 flex flex-col gap-1" data-testid="suite-nav-mobile">
          {LINKS.map((l) => <NavLink key={l.id} to={l.to} onClick={() => setOpen(false)} className={linkCls} data-testid={`suite-nav-m-${l.id}`}>{l.label}</NavLink>)}
        </nav>
      )}
    </header>
  );
}
